import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  getWizardContent,
  setWizardContent,
} from '../../util/helpers/wizardHelpers';

const StepByStep = ({
  children,
  onConfirm,
  sessionScopeStep,
  saveStepDisabled,
}) => {
  const childrenArray = React.Children.toArray(children);
  const [currentStep, setCurrentStep] = useState(
    !saveStepDisabled && getWizardContent(sessionScopeStep)
      ? Number(getWizardContent(sessionScopeStep))
      : 0,
  );

  const isLastStep = () => currentStep === children.length - 1;
  const canGoNext = () => currentStep < children.length - 1;
  const canGoBack = () => currentStep > 0;

  const goStepBack = () => {
    if (canGoBack) {
      if (!saveStepDisabled) {
        setWizardContent(sessionScopeStep, currentStep - 1);
      }
      setCurrentStep(currentStep - 1);
    }
  };

  const goToStepsBack = (step) => {
    if (canGoBack) {
      if (!saveStepDisabled) {
        setWizardContent(sessionScopeStep, currentStep - step);
      }
      setCurrentStep(currentStep - step);
    }
  };

  const skipPreviousStep = () => {
    if (canGoBack) {
      if (!saveStepDisabled) {
        setWizardContent(sessionScopeStep, currentStep - 2);
      }
      setCurrentStep(currentStep - 2);
    }
  };

  const goStepForward = () => {
    if (canGoNext) {
      if (!saveStepDisabled) {
        setWizardContent(sessionScopeStep, currentStep + 1);
      }
      setCurrentStep(currentStep + 1);
    }
  };

  const skipNextStep = () => {
    if (canGoNext) {
      if (!saveStepDisabled) {
        setWizardContent(sessionScopeStep, currentStep + 2);
      }
      setCurrentStep(currentStep + 2);
    }
  };

  useEffect(() => {
    const removeCloseListener = addCloseListener();

    if (!saveStepDisabled && !getWizardContent(sessionScopeStep)) {
      setWizardContent(sessionScopeStep, 0);
    }

    return () => removeCloseListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (typeof children === 'function') {
    return (
      <>
        {
          children({
            goStepBack,
            goStepForward,
            skipPreviousStep,
            skipNextStep,
            onConfirm,
            isLastStep,
            goToStepsBack,
          })[`${currentStep}`]
        }
      </>
    );
  }

  return childrenArray.length ? <>{childrenArray[`${currentStep}`]}</> : null;
};

function addCloseListener() {
  function closeCallback(ev) {
    ev.preventDefault();
    ev.returnValue = true; // eslint-disable-line
    return ev.returnValue;
  }

  window.addEventListener('beforeunload', closeCallback);
  return () => window.removeEventListener('beforeunload', closeCallback);
}

StepByStep.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onConfirm: PropTypes.func,
  sessionScopeStep: PropTypes.string,
  saveStepDisabled: PropTypes.bool,
};

export default StepByStep;
